import React, { useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import { apiEndpoint } from "helpers/url_helper";

import { connect } from "react-redux";
import ReactBSAlert from "react-bootstrap-sweetalert";
import {
    Col,
    Row,
    Card,
    CardBody,
    Button,
    Container,
    ButtonGroup,
    UncontrolledTooltip,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    ButtonDropdown,
    CardTitle,
} from "reactstrap"
import { setBreadcrumbItems } from "../../store/actions";
import MapContainer from "./MapContainer";
import CampusList from "./Campuslist";
import CustomTrafficFlow from "./CustomTrafficFlow";
import { CampusIdContext } from "components/Common/PageDataContext";
import TrafficMap from "./TrafficMap";

const Maps = (props) => {
    const breadcrumbItems = []

    const [selectedCampusval, setCampusValue] = useState()
    const [mainOption, setMainOption] = useState("device");
    const [trafficOption, setTrafficOption] = useState("realtime");

    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    //  Applied dates only after Search
    const [appliedDates, setAppliedDates] = useState({ from: "", to: "" });

    //  New: track if custom search is active
    const [customActive, setCustomActive] = useState(false);
    const [alert, setAlert] = useState(null);
    const Contextvalue = { selectedCampusval, setCampusValue };

    useEffect(() => {
        props.setBreadcrumbItems('Map', breadcrumbItems)
    })

    const handleMainOptionChange = (event) => {
        setMainOption(event.target.value);
        setCustomActive(false); // Reset when switching back
    };

    const handleTrafficOptionChange = (event) => {
        setTrafficOption(event.target.value);
        setCustomActive(false); // Reset when switching
    };

    const handleSearch = () => {
        if (!fromDate || !toDate) {
            setAlert(
                <ReactBSAlert
                    warning
                    title="Missing Date"
                    onConfirm={() => setAlert(null)}
                    onCancel={() => setAlert(null)}
                    confirmBtnBsStyle="info"
                >
                    Please enter both From Date and To Date!
                </ReactBSAlert>
            );
            return; // Stop execution if either date is missing
        }
        if (fromDate && toDate && new Date(fromDate) > new Date(toDate)) {
            setAlert(
                <ReactBSAlert
                    warning
                    title="Invalid Date Range"
                    onConfirm={() => setAlert(null)}
                    onCancel={() => setAlert(null)}
                    confirmBtnBsStyle="info"
                >
                    From Date cannot be greater than To Date!
                </ReactBSAlert>
            );
            return; // Stop execution
        }
        setAppliedDates({ from: fromDate, to: toDate });
        setCustomActive(true); 
    };

    useEffect(() => {
        props.setBreadcrumbItems('Map', breadcrumbItems);
        const now = new Date();
        const from = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0);
        const to = now;

        const formatDateTimeLocal = (date) => {
            const pad = (n) => n.toString().padStart(2, '0');
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
        };

        setFromDate(formatDateTimeLocal(from));
        setToDate(formatDateTimeLocal(to));
    }, []);

    return (
        <React.Fragment>
            <MetaTags>
                <title>Indus | Map</title>
            </MetaTags>
            {alert}
            <div className="d-flex align-items-center gap-2">
                <div>
                    <h5>Campus:</h5>
                    {/*<CampusIdContext.Provider value={Contextvalue}>*/}
                    <CampusIdContext.Provider value={{ selectedCampusval, setCampusValue }}>
                        <CampusList setCampusValue={setCampusValue}></CampusList>
                    </CampusIdContext.Provider>
                </div>
                {/*<MapContainer CampusID={selectedCampusval}></MapContainer>*/}
                {/* Dropdown for Device Status / Traffic Flow */}
                <div>
                    <h5>Status:</h5>
                    <select
                        value={mainOption}
                        onChange={handleMainOptionChange}
                        className="btn btn-primary dropdown-toggle"
                    >
                        <option value="device">Device</option>
                        <option value="traffic">Traffic Flow</option>
                    </select>
                </div>
                {/*  Conditional Rendering of Map */}
                {/*{selectedOption === "device" ? (*/}
                {/*    <MapContainer CampusID={selectedCampusval} />*/}
                {/*) : (*/}
                {/*        <TrafficMap CampusID={selectedCampusval} />*/}
                {/*)}*/}

                {/* Conditional sub-dropdown only if Traffic Flow is selected */}
                {mainOption === "traffic" && (
                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                        <h5>Type:</h5>
                        <select
                            value={trafficOption}
                            onChange={handleTrafficOptionChange}
                            className="btn btn-primary dropdown-toggle center"
                        >
                            <option value="realtime">Real time</option>
                            <option value="custom">Custom</option>
                        </select>
                    </div>
                )}

                {mainOption === "traffic" && trafficOption === "custom" && (
                    <div style={{ marginLeft: "10px", display: "flex", alignItems: "flex-end" }}>
                        <div style={{ display: "flex", flexDirection: "column", marginRight: "10px" }}>
                            <label style={{ marginBottom: "5px", fontWeight: "bold" }}>From</label>
                            <input
                                type="datetime-local"
                                value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                                style={{ height: "29px" }}
                            />
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", marginRight: "10px" }}>
                            <label style={{ marginBottom: "5px", fontWeight: "bold" }}>To</label>
                            <input
                                type="datetime-local"
                                value={toDate}
                                onChange={(e) => setToDate(e.target.value)}
                                style={{ height: "29px" }}
                            />
                        </div>

                        <Button
                            color="primary"
                            onClick={handleSearch}
                            style={{ marginLeft: "20px", marginTop: "0px", height: "33px" }}
                        >
                            Search
                        </Button>
                    </div>

                )}
            </div>

            <br /><br />
            {/* Conditional rendering after search */}
            {/*{mainOption === "device" && <MapContainer CampusID={selectedCampusval} />}*/}

            {/*{*/}
            {/*    mainOption === "traffic" && searchPressed && (*/}
            {/*        trafficOption === "realtime" ?*/}
            {/*            <TrafficMap CampusID={selectedCampusval} /> :*/}
            {/*            <CustomTrafficFlow CampusID={selectedCampusval} fromDate={fromDate} toDate={toDate} />*/}
            {/*    )*/}
            {/*}*/}

            {/* Conditional Rendering */}

            {/*  Show Device Status */}
            {mainOption === "device" && <MapContainer CampusID={selectedCampusval} />}

            {/* Traffic Flow */}
            {mainOption === "traffic" && (
                trafficOption === "realtime" ? (
                    <TrafficMap CampusID={selectedCampusval} />
                ) : (
                    customActive ? (
                        <CustomTrafficFlow
                            CampusID={selectedCampusval}
                            fromDate={appliedDates.from}
                            toDate={appliedDates.to}
                        />
                    ) : (
                        //  Default = Realtime until Search clicked
                        <TrafficMap CampusID={selectedCampusval} />
                    )
                )
            )}
        </React.Fragment >
    );
};

export default connect(null, { setBreadcrumbItems })(Maps);

